import React, { h } from 'preact'

interface Props {
    variant: 'compact' | 'large'
}

import style from './title.css'

export const Title: React.FunctionalComponent<Props> = ({
    children,
    variant,
}) => {
    return (
        <div className={variant === 'compact' ? style.compact : style.large}>
            {children}
        </div>
    )
}
